export const HTTP_ERRORS_CODE = {
  FORBIDDEN_EMPLOYEES_ACCESS:
    'organisation/access_restriction/forbidden_employees',
  AUTHENTICATION_REFUSED: 'authentication_refused',
};
